import { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { Backdrop, Container, Grow, Modal, Stack, styled, Typography } from "@mui/material";
import CustomPaper from "../../../_components/CustomPaper";
import FutureBotClose from "./FutureBotClose";
import { BotSeverity } from "../../../_app/types";

interface Props {
  open: boolean;
  onClose: (value: boolean) => void;
  botId: string;
  profileId: string;
  accountId: string;
  isAutobot?: boolean;
  status: BotSeverity,
}

const CustomBackdrop = styled(Backdrop)(({ theme }) => ({
  backdropFilter: "blur(6px)",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
}));

const FutureBotClosePopup = (props: Props) => {
  const theme = useTheme();

  useEffect(() => {
    const muiContainers = document.querySelectorAll(".MuiContainer-root");
    if (props.open) {
      muiContainers.forEach((container) => {
        (container as HTMLElement).classList.add("ui-disabled");
      });
    } else {
      muiContainers.forEach((container) => {
        (container as HTMLElement).classList.remove("ui-disabled");
      });
    }

    return () => {
      muiContainers.forEach((container) => {
        (container as HTMLElement).style.opacity = "1";
      });
    };
  }, [props.open]);

  const handleClose = () => props.onClose(false);

  return (
    <Modal open={props.open} onClose={handleClose} slots={{ backdrop: CustomBackdrop }}>
      <Grow in={props.open}>
        <Container
          className={"NoOpacity"}
          maxWidth={"xl"}
          sx={{
            position: "fixed",
            top: "25%",
            left: 0,
            zIndex: 100,
            width: "100%",
            paddingLeft: "20px !important",
            paddingRight: "20px !important",
          }}
        >
          <CustomPaper sx={{ borderRadius: 2, paddingTop: 2 }} color={theme.palette.grey[300]}>
            <Stack direction={"column"} spacing={1}>
              <Stack direction={"column"} spacing={2}>
                <Typography
                  fontWeight={700}
                  textTransform={"uppercase"}
                  variant="body2"
                  color={"textSecondary"}
                >
                  Are You Sure You Want to Close Bot?
                </Typography>
                <Typography variant="body2" color={"textSecondary"}>
                  Closing this bot will immediately stop its trading activities, and any ongoing
                  orders will be canceled. You can restart it later, but the current session’s data
                  will be lost.
                </Typography>
              </Stack>
              <FutureBotClose
                onChange={props.onClose}
                botId={props.botId}
                profileId={props.profileId}
                accountId={props.accountId}
                isAutobot={props.isAutobot}
                status={props.status}
              />
            </Stack>
          </CustomPaper>
        </Container>
      </Grow>
    </Modal>
  );
};

export default FutureBotClosePopup;
